// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monitoring-page {
  height: 100vh;
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.4) 0%,   /* #667eea → 알파값 0.4 */
    rgba(118, 75, 162, 0.4) 100%   /* #764ba2 → 알파값 0.4 */
  );
  background-attachment: fixed;
  backdrop-filter: blur(20px);
  padding: 10px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.monitoring-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.85);
  padding: 15px 25px;
  border-radius: 15px;
  margin-bottom: 15px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(15px);
  height: 70px;
  position: relative;
  z-index: 10;
}

.monitoring-title h1 {
  margin: 0 0 10px 0;
  color: #2c3e50;
  font-size: 2.2em;
  font-weight: 700;
}

.monitoring-status {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666;
  font-size: 1.1em;
}

.status-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #27ae60;
  animation: pulse 2s infinite;
}

.status-indicator.loading {
  background: #f39c12;
  animation: spin 1s linear infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.monitoring-controls {
  display: flex;
  align-items: center;
  gap: 15px;
}

.page-info {
  font-weight: 700;
  color: #2c3e50;
  background: rgba(255, 255, 255, 0.9);
  padding: 8px 15px;
  border-radius: 20px;
  font-size: 1em;
}

.control-buttons {
  display: flex;
  align-items: stretch;
  gap: 5px;
  height: 50px;
}

.nav-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 5px 8px;
  padding: 10px 15px;
  text-align: center;
  font-size: 16px;
  letter-spacing: 1px;
  text-decoration: none;
  color: #725AC1;
  background: transparent;
  cursor: pointer;
  transition: ease-out 0.5s;
  border: 2px solid #725AC1;
  border-radius: 10px;
  box-shadow: inset 0 0 0 0 #725AC1;
  width: 40px;
  height: 40px;
}

.nav-button:hover {
  color: white;
  box-shadow: inset 0 -100px 0 0 #725AC1;
}

.nav-button:active {
  transform: scale(0.9);
}

.interval-setting {
  display: flex;
  align-items: center;
  gap: 5px;
}

.interval-input {
  width: 60px;
  padding: 8px;
  border: 2px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
  background: rgba(255, 255, 255, 0.9);
}

.interval-label {
  font-size: 14px;
  color: #2c3e50;
  font-weight: 600;
}

.auto-button {
  position: relative;
  display: inline-block;
  margin: 5px 8px;
  padding: 10px 20px;
  text-align: center;
  font-size: 14px;
  letter-spacing: 1px;
  text-decoration: none;
  color: #725AC1;
  background: transparent;
  cursor: pointer;
  transition: ease-out 0.5s;
  border: 2px solid #725AC1;
  border-radius: 10px;
  box-shadow: inset 0 0 0 0 #725AC1;
}

.auto-button.active {
  color: white;
  box-shadow: inset 0 -100px 0 0 #27ae60;
  border-color: #27ae60;
}

.auto-button:hover {
  color: white;
  box-shadow: inset 0 -100px 0 0 #725AC1;
}

.auto-button:active {
  transform: scale(0.9);
}

.refresh-button, .back-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 5px 8px;
  padding: 0 24px;
  text-align: center;
  font-size: 16px;
  letter-spacing: 1px;
  text-decoration: none;
  background: transparent;
  cursor: pointer;
  transition: ease-out 0.5s;
  border: 2px solid #725AC1;
  border-radius: 10px;
  box-shadow: inset 0 0 0 0 #725AC1;
  height: 100%;
}

.refresh-button {
  color: #3498db;
  border-color: #3498db;
  box-shadow: inset 0 0 0 0 #3498db;
}

.refresh-button:hover:not(:disabled) {
  color: white;
  box-shadow: inset 0 -100px 0 0 #3498db;
}

.refresh-button:active {
  transform: scale(0.9);
}

.refresh-button:disabled {
  color: #bdc3c7;
  border-color: #bdc3c7;
  cursor: not-allowed;
  box-shadow: inset 0 0 0 0 #bdc3c7;
}

.refresh-button:disabled:hover {
  color: #bdc3c7;
  box-shadow: inset 0 0 0 0 #bdc3c7;
}

.back-button {
  color: #e74c3c;
  border-color: #e74c3c;
  box-shadow: inset 0 0 0 0 #e74c3c;
}

.back-button:hover {
  color: white;
  box-shadow: inset 0 -100px 0 0 #e74c3c;
}

.back-button:active {
  transform: scale(0.9);
}

.monitoring-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1 1;
  overflow: hidden;
}

/* 1) 그룹 래퍼: 남는 세로공간을 위로 몰고, 스크롤 허용 */
.monitoring-groups {
  display: grid;
  gap: 8px;
  height: calc(100vh - 190px);
  width: 100%;
  margin: 0;
  padding: 0;
  overflow: auto;            /* 필요 시 세로 스크롤 */
  align-content: start;      /* 남는 세로공간을 위로 */
  min-height: 0;             /* 자식 overflow 계산 안정화 */
}

.monitoring-groups:has(.group-8) {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
}

/* 페이지별 레이아웃 */
.monitoring-groups.page-1 {
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
}

.monitoring-groups.page-2 {
  grid-template-columns: 1fr 1fr !important;
  grid-template-rows: 1fr;
  overflow: hidden;
}

.monitoring-groups.page-3 {
  grid-template-columns: 1fr 1fr 1fr !important;
  grid-template-rows: 1fr;
  overflow: hidden;
}

.monitoring-groups.page-4 {
  grid-template-columns: repeat(4, 1fr) !important;
  grid-template-rows: 1fr;
  overflow: hidden;
}

.monitoring-groups:has(.group-6):not(:has(.group-8)) {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
}

.monitoring-groups:has(.group-4):not(:has(.group-1)) {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
}

.monitoring-groups:has(.group-4):has(.group-1) {
  grid-template-columns: 1fr 1fr 0.8fr;
  grid-template-rows: 1fr;
}

.monitoring-groups:has(.group-3) {
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 1fr;
}

.monitoring-group {
  background: rgba(255, 255, 255, 0.85);
  border-radius: 15px;
  padding: 10px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(15px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 120px;
}

.group-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  padding: 15px 0 20px 8px;
  border-bottom: 2px solid #3498db;
  flex-shrink: 0;
}

.group-header h3 {
  margin: 0;
  color: #2c3e50;
  font-size: 4.25em;
  font-weight: 900;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
  padding: 10px 10px;
}

.group-count {
  color: #666;
  font-size: 1.2em;
  background: rgba(52, 152, 219, 0.1);
  padding: 5px 12px;
  border-radius: 15px;
  font-weight: 600;
}

/* 2) 카드 그리드: 높이 강제 제거, 트랙은 내용 기준으로 + 최소 높이 확보 */
.monitoring-grid {
  display: grid;
  gap: 8px;
  flex: 1 1;
  /* align-content: stretch;  기본값은 stretch지만, start가 더 안전 */
  align-content: start;      
  align-items: stretch;
  /* height: 90%;            제거 → 남는 공간 강제 분배 방지 */
  padding: 5px;
  min-height: 0;
  /* 각 행의 기본 높이를 120px 이상으로 통일하고, 넘치면 자동 확장 */
  grid-auto-rows: minmax(120px, auto);
}

.grid-8 {
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
}

.grid-6 {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
}

.grid-4 {
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
}

.grid-3 {
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, 1fr);
}

.grid-1 {
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
}

/* Shinko 그룹을 4개 센서 그룹과 비슷하게 */
.monitoring-groups:has(.group-4) .group-1 {
  padding: 10px;
}

.monitoring-groups:has(.group-4) .group-1 .monitoring-box {
  min-height: 60px;
  padding: 8px;
}

.monitoring-groups:has(.group-4) .group-1 .monitoring-machine {
  font-size: 29px;
}

.monitoring-groups:has(.group-4) .group-1 .monitoring-temp {
  font-size: 39px;
}

.monitoring-groups:has(.group-4) .group-1 .monitoring-range {
  font-size: 20px;
}

.monitoring-groups:has(.group-4) .group-1 .group-header h3 {
  font-size: 5.25em;
  padding: 10px 20px;
}

.monitoring-box {
  border: 2px solid #ddd;
  border-radius: 8px;
  padding: 6px;
  text-align: center;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height:100%;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  z-index: 2;
}

.monitoring-box:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.monitoring-box.no-data {
  background-color: #95a5a6;
  color: white;
}

.monitoring-box.normal,
.monitoring-box.low-temp,
.monitoring-box.high-temp,
.monitoring-box.abnormal {
  color: rgb(41, 40, 40);
}

.monitoring-machine {
  font-size: 27px;
  margin-bottom: 2px;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0,0,0,0.3);
}

.monitoring-temp {
  font-size: 35px;
  margin-bottom: 2px;
  font-weight: 700;
  line-height: 1.1;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.monitoring-range {
  font-size: 20px;
  line-height: 1.1;
  overflow: hidden;
  text-align: center;
  width: 100%;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0,0,0,0.3);
}

.monitoring-legend {
  display: flex;
  justify-content: center;
  gap: 20px;
  font-size: 16px;
  margin: 2px 0 0 0;
  padding: 8px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  flex-shrink: 0;
  backdrop-filter: blur(10px);
}

/* 반응형 디자인 */
@media (max-width: 768px) {
  .monitoring-page {
    padding: 10px;
  }
  
  .monitoring-header {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
  
  .monitoring-title h1 {
    font-size: 1.8em;
  }
  
  .monitoring-summary {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .summary-value {
    font-size: 2em;
  }
}

/* 뱃지 컨테이너 */
.badge-container {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  justify-content: center;
  flex-wrap: wrap;
}

/* 공통 뱃지 스타일 */
.count-badge,
.inactive-badge {
  display: inline-block;
  padding: 12px 0;
  border-radius: 15px;
  font-size: 24px;
  font-weight: 800;
  text-align: center;
  min-width: 80px;
}

/* 개수 뱃지 스타일 */
.count-badge {
  background: #725AC1;
  color: white;
  border: 1px solid #725AC1;
}

/* 비가동 뱃지 스타일 */
.inactive-badge {
  background: #e74c3c;
  color: white;
  border: 1px solid #c0392b;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.7; }
  100% { opacity: 1; }
}`, "",{"version":3,"sources":["webpack://./src/pages/MonitoringPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb;;;;GAIC;EACD,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;EACjC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,SAAS;EACT,UAAU;EACV,cAAc,aAAa,gBAAgB;EAC3C,oBAAoB,OAAO,gBAAgB;EAC3C,aAAa,cAAc,uBAAuB;AACpD;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,cAAc;AACd;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,wBAAwB;EACxB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,QAAQ;EACR,SAAO;EACP,yDAAyD;EACzD,oBAAoB;EACpB,oBAAoB;EACpB,gDAAgD;EAChD,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA,cAAc;AACd;;EAEE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB","sourcesContent":[".monitoring-page {\r\n  height: 100vh;\r\n  background: linear-gradient(\r\n    135deg,\r\n    rgba(102, 126, 234, 0.4) 0%,   /* #667eea → 알파값 0.4 */\r\n    rgba(118, 75, 162, 0.4) 100%   /* #764ba2 → 알파값 0.4 */\r\n  );\r\n  background-attachment: fixed;\r\n  backdrop-filter: blur(20px);\r\n  padding: 10px;\r\n  box-sizing: border-box;\r\n  overflow: hidden;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.monitoring-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background: rgba(255, 255, 255, 0.85);\r\n  padding: 15px 25px;\r\n  border-radius: 15px;\r\n  margin-bottom: 15px;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\r\n  backdrop-filter: blur(15px);\r\n  height: 70px;\r\n  position: relative;\r\n  z-index: 10;\r\n}\r\n\r\n.monitoring-title h1 {\r\n  margin: 0 0 10px 0;\r\n  color: #2c3e50;\r\n  font-size: 2.2em;\r\n  font-weight: 700;\r\n}\r\n\r\n.monitoring-status {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  color: #666;\r\n  font-size: 1.1em;\r\n}\r\n\r\n.status-indicator {\r\n  width: 12px;\r\n  height: 12px;\r\n  border-radius: 50%;\r\n  background: #27ae60;\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n.status-indicator.loading {\r\n  background: #f39c12;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes pulse {\r\n  0%, 100% { opacity: 1; }\r\n  50% { opacity: 0.5; }\r\n}\r\n\r\n@keyframes spin {\r\n  from { transform: rotate(0deg); }\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n.monitoring-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n}\r\n\r\n.page-info {\r\n  font-weight: 700;\r\n  color: #2c3e50;\r\n  background: rgba(255, 255, 255, 0.9);\r\n  padding: 8px 15px;\r\n  border-radius: 20px;\r\n  font-size: 1em;\r\n}\r\n\r\n.control-buttons {\r\n  display: flex;\r\n  align-items: stretch;\r\n  gap: 5px;\r\n  height: 50px;\r\n}\r\n\r\n.nav-button {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 5px 8px;\r\n  padding: 10px 15px;\r\n  text-align: center;\r\n  font-size: 16px;\r\n  letter-spacing: 1px;\r\n  text-decoration: none;\r\n  color: #725AC1;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  transition: ease-out 0.5s;\r\n  border: 2px solid #725AC1;\r\n  border-radius: 10px;\r\n  box-shadow: inset 0 0 0 0 #725AC1;\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n\r\n.nav-button:hover {\r\n  color: white;\r\n  box-shadow: inset 0 -100px 0 0 #725AC1;\r\n}\r\n\r\n.nav-button:active {\r\n  transform: scale(0.9);\r\n}\r\n\r\n.interval-setting {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n\r\n.interval-input {\r\n  width: 60px;\r\n  padding: 8px;\r\n  border: 2px solid #ddd;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  text-align: center;\r\n  background: rgba(255, 255, 255, 0.9);\r\n}\r\n\r\n.interval-label {\r\n  font-size: 14px;\r\n  color: #2c3e50;\r\n  font-weight: 600;\r\n}\r\n\r\n.auto-button {\r\n  position: relative;\r\n  display: inline-block;\r\n  margin: 5px 8px;\r\n  padding: 10px 20px;\r\n  text-align: center;\r\n  font-size: 14px;\r\n  letter-spacing: 1px;\r\n  text-decoration: none;\r\n  color: #725AC1;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  transition: ease-out 0.5s;\r\n  border: 2px solid #725AC1;\r\n  border-radius: 10px;\r\n  box-shadow: inset 0 0 0 0 #725AC1;\r\n}\r\n\r\n.auto-button.active {\r\n  color: white;\r\n  box-shadow: inset 0 -100px 0 0 #27ae60;\r\n  border-color: #27ae60;\r\n}\r\n\r\n.auto-button:hover {\r\n  color: white;\r\n  box-shadow: inset 0 -100px 0 0 #725AC1;\r\n}\r\n\r\n.auto-button:active {\r\n  transform: scale(0.9);\r\n}\r\n\r\n.refresh-button, .back-button {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 5px 8px;\r\n  padding: 0 24px;\r\n  text-align: center;\r\n  font-size: 16px;\r\n  letter-spacing: 1px;\r\n  text-decoration: none;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  transition: ease-out 0.5s;\r\n  border: 2px solid #725AC1;\r\n  border-radius: 10px;\r\n  box-shadow: inset 0 0 0 0 #725AC1;\r\n  height: 100%;\r\n}\r\n\r\n.refresh-button {\r\n  color: #3498db;\r\n  border-color: #3498db;\r\n  box-shadow: inset 0 0 0 0 #3498db;\r\n}\r\n\r\n.refresh-button:hover:not(:disabled) {\r\n  color: white;\r\n  box-shadow: inset 0 -100px 0 0 #3498db;\r\n}\r\n\r\n.refresh-button:active {\r\n  transform: scale(0.9);\r\n}\r\n\r\n.refresh-button:disabled {\r\n  color: #bdc3c7;\r\n  border-color: #bdc3c7;\r\n  cursor: not-allowed;\r\n  box-shadow: inset 0 0 0 0 #bdc3c7;\r\n}\r\n\r\n.refresh-button:disabled:hover {\r\n  color: #bdc3c7;\r\n  box-shadow: inset 0 0 0 0 #bdc3c7;\r\n}\r\n\r\n.back-button {\r\n  color: #e74c3c;\r\n  border-color: #e74c3c;\r\n  box-shadow: inset 0 0 0 0 #e74c3c;\r\n}\r\n\r\n.back-button:hover {\r\n  color: white;\r\n  box-shadow: inset 0 -100px 0 0 #e74c3c;\r\n}\r\n\r\n.back-button:active {\r\n  transform: scale(0.9);\r\n}\r\n\r\n.monitoring-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  flex: 1;\r\n  overflow: hidden;\r\n}\r\n\r\n/* 1) 그룹 래퍼: 남는 세로공간을 위로 몰고, 스크롤 허용 */\r\n.monitoring-groups {\r\n  display: grid;\r\n  gap: 8px;\r\n  height: calc(100vh - 190px);\r\n  width: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  overflow: auto;            /* 필요 시 세로 스크롤 */\r\n  align-content: start;      /* 남는 세로공간을 위로 */\r\n  min-height: 0;             /* 자식 overflow 계산 안정화 */\r\n}\r\n\r\n.monitoring-groups:has(.group-8) {\r\n  grid-template-columns: 1fr 1fr;\r\n  grid-template-rows: 1fr;\r\n}\r\n\r\n/* 페이지별 레이아웃 */\r\n.monitoring-groups.page-1 {\r\n  grid-template-columns: 1fr;\r\n  grid-template-rows: 1fr;\r\n}\r\n\r\n.monitoring-groups.page-2 {\r\n  grid-template-columns: 1fr 1fr !important;\r\n  grid-template-rows: 1fr;\r\n  overflow: hidden;\r\n}\r\n\r\n.monitoring-groups.page-3 {\r\n  grid-template-columns: 1fr 1fr 1fr !important;\r\n  grid-template-rows: 1fr;\r\n  overflow: hidden;\r\n}\r\n\r\n.monitoring-groups.page-4 {\r\n  grid-template-columns: repeat(4, 1fr) !important;\r\n  grid-template-rows: 1fr;\r\n  overflow: hidden;\r\n}\r\n\r\n.monitoring-groups:has(.group-6):not(:has(.group-8)) {\r\n  grid-template-columns: 1fr 1fr;\r\n  grid-template-rows: 1fr;\r\n}\r\n\r\n.monitoring-groups:has(.group-4):not(:has(.group-1)) {\r\n  grid-template-columns: 1fr 1fr;\r\n  grid-template-rows: 1fr;\r\n}\r\n\r\n.monitoring-groups:has(.group-4):has(.group-1) {\r\n  grid-template-columns: 1fr 1fr 0.8fr;\r\n  grid-template-rows: 1fr;\r\n}\r\n\r\n.monitoring-groups:has(.group-3) {\r\n  grid-template-columns: repeat(4, 1fr);\r\n  grid-template-rows: 1fr;\r\n}\r\n\r\n.monitoring-group {\r\n  background: rgba(255, 255, 255, 0.85);\r\n  border-radius: 15px;\r\n  padding: 10px;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\r\n  backdrop-filter: blur(15px);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  min-height: 120px;\r\n}\r\n\r\n.group-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 15px;\r\n  padding: 15px 0 20px 8px;\r\n  border-bottom: 2px solid #3498db;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.group-header h3 {\r\n  margin: 0;\r\n  color: #2c3e50;\r\n  font-size: 4.25em;\r\n  font-weight: 900;\r\n  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);\r\n  padding: 10px 10px;\r\n}\r\n\r\n.group-count {\r\n  color: #666;\r\n  font-size: 1.2em;\r\n  background: rgba(52, 152, 219, 0.1);\r\n  padding: 5px 12px;\r\n  border-radius: 15px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* 2) 카드 그리드: 높이 강제 제거, 트랙은 내용 기준으로 + 최소 높이 확보 */\r\n.monitoring-grid {\r\n  display: grid;\r\n  gap: 8px;\r\n  flex: 1;\r\n  /* align-content: stretch;  기본값은 stretch지만, start가 더 안전 */\r\n  align-content: start;      \r\n  align-items: stretch;\r\n  /* height: 90%;            제거 → 남는 공간 강제 분배 방지 */\r\n  padding: 5px;\r\n  min-height: 0;\r\n  /* 각 행의 기본 높이를 120px 이상으로 통일하고, 넘치면 자동 확장 */\r\n  grid-auto-rows: minmax(120px, auto);\r\n}\r\n\r\n.grid-8 {\r\n  grid-template-columns: repeat(4, 1fr);\r\n  grid-template-rows: repeat(2, 1fr);\r\n}\r\n\r\n.grid-6 {\r\n  grid-template-columns: repeat(3, 1fr);\r\n  grid-template-rows: repeat(2, 1fr);\r\n}\r\n\r\n.grid-4 {\r\n  grid-template-columns: repeat(2, 1fr);\r\n  grid-template-rows: repeat(2, 1fr);\r\n}\r\n\r\n.grid-3 {\r\n  grid-template-columns: 1fr;\r\n  grid-template-rows: repeat(3, 1fr);\r\n}\r\n\r\n.grid-1 {\r\n  grid-template-columns: 1fr;\r\n  grid-template-rows: 1fr;\r\n}\r\n\r\n/* Shinko 그룹을 4개 센서 그룹과 비슷하게 */\r\n.monitoring-groups:has(.group-4) .group-1 {\r\n  padding: 10px;\r\n}\r\n\r\n.monitoring-groups:has(.group-4) .group-1 .monitoring-box {\r\n  min-height: 60px;\r\n  padding: 8px;\r\n}\r\n\r\n.monitoring-groups:has(.group-4) .group-1 .monitoring-machine {\r\n  font-size: 29px;\r\n}\r\n\r\n.monitoring-groups:has(.group-4) .group-1 .monitoring-temp {\r\n  font-size: 39px;\r\n}\r\n\r\n.monitoring-groups:has(.group-4) .group-1 .monitoring-range {\r\n  font-size: 20px;\r\n}\r\n\r\n.monitoring-groups:has(.group-4) .group-1 .group-header h3 {\r\n  font-size: 5.25em;\r\n  padding: 10px 20px;\r\n}\r\n\r\n.monitoring-box {\r\n  border: 2px solid #ddd;\r\n  border-radius: 8px;\r\n  padding: 6px;\r\n  text-align: center;\r\n  font-weight: bold;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height:100%;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  overflow: hidden;\r\n  box-sizing: border-box;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.monitoring-box:hover {\r\n  transform: translateY(-3px);\r\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.monitoring-box.no-data {\r\n  background-color: #95a5a6;\r\n  color: white;\r\n}\r\n\r\n.monitoring-box.normal,\r\n.monitoring-box.low-temp,\r\n.monitoring-box.high-temp,\r\n.monitoring-box.abnormal {\r\n  color: rgb(41, 40, 40);\r\n}\r\n\r\n.monitoring-machine {\r\n  font-size: 27px;\r\n  margin-bottom: 2px;\r\n  line-height: 1.2;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  width: 100%;\r\n  font-weight: 600;\r\n  text-shadow: 0 1px 2px rgba(0,0,0,0.3);\r\n}\r\n\r\n.monitoring-temp {\r\n  font-size: 35px;\r\n  margin-bottom: 2px;\r\n  font-weight: 700;\r\n  line-height: 1.1;\r\n  text-shadow: 0 2px 4px rgba(0,0,0,0.3);\r\n}\r\n\r\n.monitoring-range {\r\n  font-size: 20px;\r\n  line-height: 1.1;\r\n  overflow: hidden;\r\n  text-align: center;\r\n  width: 100%;\r\n  font-weight: 500;\r\n  text-shadow: 0 1px 2px rgba(0,0,0,0.3);\r\n}\r\n\r\n.monitoring-legend {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 20px;\r\n  font-size: 16px;\r\n  margin: 2px 0 0 0;\r\n  padding: 8px;\r\n  background: rgba(255, 255, 255, 0.8);\r\n  border-radius: 10px;\r\n  flex-shrink: 0;\r\n  backdrop-filter: blur(10px);\r\n}\r\n\r\n/* 반응형 디자인 */\r\n@media (max-width: 768px) {\r\n  .monitoring-page {\r\n    padding: 10px;\r\n  }\r\n  \r\n  .monitoring-header {\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .monitoring-title h1 {\r\n    font-size: 1.8em;\r\n  }\r\n  \r\n  .monitoring-summary {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n  \r\n  .summary-value {\r\n    font-size: 2em;\r\n  }\r\n}\r\n\r\n/* 뱃지 컨테이너 */\r\n.badge-container {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-top: 8px;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* 공통 뱃지 스타일 */\r\n.count-badge,\r\n.inactive-badge {\r\n  display: inline-block;\r\n  padding: 12px 0;\r\n  border-radius: 15px;\r\n  font-size: 24px;\r\n  font-weight: 800;\r\n  text-align: center;\r\n  min-width: 80px;\r\n}\r\n\r\n/* 개수 뱃지 스타일 */\r\n.count-badge {\r\n  background: #725AC1;\r\n  color: white;\r\n  border: 1px solid #725AC1;\r\n}\r\n\r\n/* 비가동 뱃지 스타일 */\r\n.inactive-badge {\r\n  background: #e74c3c;\r\n  color: white;\r\n  border: 1px solid #c0392b;\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n@keyframes pulse {\r\n  0% { opacity: 1; }\r\n  50% { opacity: 0.7; }\r\n  100% { opacity: 1; }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
